<template>
  <a-drawer :title="title" :width="720" :visible="visible" :body-style="{ paddingBottom: '80px', padding: 0 }" @close="onClose">
    <a-alert v-if="!index && index !== 0" message="新增的线路，将在“重新提交排线”后合并计算" type="info" show-icon />
    <a-alert v-if="form.remark" :message="`排线失败原因: ${form.remark}`" banner />
    <a-form-model ref="form" :model="form" :rules="rules" layout="vertical">
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-model-item label="Est.Departure Date" prop="planTime">
            <a-date-picker v-model="form.planTime" value-format="YYYY-MM-DD" placeholder="请选择发货日期" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="DC&SKU" prop="dcAndSku">
            <a-input v-model="form.dcAndSku" placeholder="请输入DC&SKU" />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-model-item label="Supplier" prop="supplierCode">
            <a-input v-model="form.supplierCode" :max-length="100" placeholder="请输入供应商" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="Depot" prop="warehouseCode">
            <a-input v-model="form.warehouseCode" :max-length="100" placeholder="请输入仓库" />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-model-item label="SKU" prop="skuCode">
            <a-input v-model="form.skuCode" placeholder="请输入SKU" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="Description" prop="skuName">
            <a-input v-model="form.skuName" placeholder="请输入SKU描述" />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-model-item label="Packing" prop="packing">
            <a-input v-model="form.packing" placeholder="请输入Packing" />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-model-item label="Pallet" prop="skuPallet">
            <a-input-number v-model="form.skuPallet" class="input-number" :min="0" placeholder="请输入拍数" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="Case" prop="skuAmount">
            <a-input-number v-model="form.skuAmount" class="input-number" :min="0" placeholder="请输入箱数" />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-model-item label="Qty" prop="qty">
            <a-input v-model="form.qty" placeholder="请输入Qty" />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-model-item label="集散中心" prop="entrepot">
            <a-input v-model="form.entrepot" placeholder="请输入集散中心" />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
    <div
      :style="{
        position: 'absolute',
        right: 0,
        bottom: 0,
        width: '100%',
        borderTop: '1px solid #e9e9e9',
        padding: '10px 16px',
        background: '#fff',
        textAlign: 'right',
        zIndex: 1,
      }"
    >
      <a-button style="margin-right: 8px" @click="onClose">取 消</a-button>
      <a-button type="primary" @click="handleSubmit">保 存</a-button>
    </div>
  </a-drawer>
</template>

<script>
import moment from "moment";

export default {
  name: "EditDialog",
  data() {
    return {
      form: {},
      visible: false,
      title: "新增线路",
      rules: {
        planTime: [{ required: true, message: "请选择发货日期", trigger: "change" }],
        supplierCode: [{ required: true, message: "请输入供应商", trigger: "change" }],
        warehouseCode: [{ required: true, message: "请输入仓库", trigger: "change" }],
		skuPallet: [{ required: true, message: "请输入拍数", trigger: "change" }],
		skuAmount: [{ required: true, message: "请输入箱数", trigger: "change" }],
      },
      index: null,
    };
  },
  methods: {
    show(item, index) {
      this.title = !index && index !== 0 ? "新增线路" : "编辑线路";
      if (item) {
        this.form = {
          ...item,
          planTime: item.planTime ? moment(item.planTime).format("YYYY-MM-DD") : "",
        };
        this.index = index;
      }
      this.visible = true;
    },
    onClose() {
      this.$refs.form.clearValidate();
      this.form = {};
      this.index = null;
      this.visible = false;
    },
    async handleSubmit() {
      await this.$refs.form.validate();
      if (!this.index && this.index !== 0) {
        this.$emit("lineAdd", this.form);
      } else {
        this.$emit("lineEdit", this.form, this.index);
      }
      this.onClose();
    },
  },
};
</script>

<style lang="less" scoped>
.ant-calendar-picker {
  width: 100%;
}
.ant-form {
  padding: 24px;

  .input-number {
	width: 100%;
  }
}
.ant-alert-info {
  background-color: #d9e9fc;
  border: 0;
  /deep/.ant-alert-message {
    color: #2a7cd6;
  }
  /deep/.ant-alert-icon {
    color: #2a7cd6;
  }
}
</style>
